import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { dashboardPath, useAuth } from "@/context/AuthContext";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Rewards", href: "#rewards" },
  { label: "Products", href: "#products" },
  { label: "Live & Learn", href: "#live-learn" },
  { label: "Lucky Draw", href: "#lucky-draw" },
  { label: "AI Engine", href: "#ai" },
];

export default function PublicNavbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const dashboard = user ? dashboardPath(user.role) : null;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#050506]/80 backdrop-blur-xl border-b border-[#222530] safe-top">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-[#94A3B8] hover:text-white transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {dashboard ? (
            <button
              data-testid="nav-dashboard-button"
              onClick={() => navigate(dashboard)}
              className="btn-gold px-5 py-2 text-sm"
            >
              Dashboard
            </button>
          ) : (
            <>
              <button
                data-testid="nav-login-button"
                onClick={() => navigate("/login")}
                className="btn-outline-gold px-5 py-2 text-sm"
              >
                Login
              </button>
              <button
                data-testid="nav-register-button"
                onClick={() => navigate("/register")}
                className="btn-gold px-5 py-2 text-sm"
              >
                Register
              </button>
            </>
          )}
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#222530] bg-[#050506]/95 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="py-3 px-2 text-sm text-[#94A3B8] hover:text-white border-b border-[#222530]/60 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="flex gap-3 pt-4">
              {dashboard ? (
                <button
                  data-testid="mobile-nav-dashboard-button"
                  onClick={() => navigate(dashboard)}
                  className="btn-gold flex-1 py-2.5 text-sm"
                >
                  Dashboard
                </button>
              ) : (
                <>
                  <button
                    data-testid="mobile-nav-login-button"
                    onClick={() => navigate("/login")}
                    className="btn-outline-gold flex-1 py-2.5 text-sm"
                  >
                    Login
                  </button>
                  <button
                    data-testid="mobile-nav-register-button"
                    onClick={() => navigate("/register")}
                    className="btn-gold flex-1 py-2.5 text-sm"
                  >
                    Register
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
